"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSpecification = exports.PackageType = void 0;
var destination_1 = require("./destination");
/**
 * Packaging interface
 * @doc Packaging
 */
var PackageType;
(function (PackageType) {
    PackageType["HLS"] = "hls";
    PackageType["DASH"] = "dash";
})(PackageType = exports.PackageType || (exports.PackageType = {}));
/**
 * Packaging
 * @doc Packaging
 */
var PackagingSpecification = /** @class */ (function () {
    function PackagingSpecification(data) {
        this.destination = undefined;
        this.chunkDuration = undefined;
        this.packageType = undefined;
        this.chunkDuration = data.chunkDuration;
        if (data.destination) {
            this.destination = new destination_1.Destination(data.destination);
        }
        this.packageType = data.packageType;
    }
    return PackagingSpecification;
}());
exports.PackagingSpecification = PackagingSpecification;
//# sourceMappingURL=packaging-specification.js.map